module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/tea_fa3adc.jpg";